import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

export interface ImportSubjectStatus {
  companyId: string;
  subjectName: string;
  currentPhase: number;
  lastResult: number;
  lastSyncStarted: string | null;
  lastSyncCompleted: string | null;
  lastError: string | null;
  totalCardsProcessed: number;
  errorCount: number;
}

export enum ImportPhase {
  Idle = 0,
  UpdatingTokens = 1,
  UpdatingWasteCodes = 2,
  UpdatingRepository = 3,
  Filing = 4,
}

export enum ImportResult {
  Unknown = 0,
  Running = 1,
  Success = 2,
  Error = 3,
}

@Injectable({ providedIn: "root" })
export class ImportStatusService {
  constructor(private http: HttpClient) {}

  getStatuses(): Observable<ImportSubjectStatus[]> {
    return this.http.get<ImportSubjectStatus[]>("/api/ImportStatus");
  }
}
